import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "bridge-config"
  }, [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    ref: "bridgeConfig",
    attrs: {
      "items": _vm.localBridgeConfigs,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.bridgeSelection'),
      "item-value": "configId",
      "item-text": "title",
      "autocomplete": "off",
      "hide-details": "",
      "return-object": "",
      "disabled": _vm.templateContext || _vm.mode === 'readonly',
      "error": _vm.showRetryButton,
      "data-cy": "bridge-select"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemAvatar, [_c(VAvatar, {
          attrs: {
            "size": "32"
          }
        }, [data.item.image ? _c('img', {
          attrs: {
            "src": data.item.image,
            "alt": data.item.title,
            "title": data.item.title
          }
        }) : _vm._e()])], 1), _c(VListItemContent, [_c(VListItemTitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.title)
          }
        }), _c(VListItemSubtitle, [_vm._v("ID " + _vm._s(data.item.configId))])], 1)];
      }
    }, {
      key: "prepend-inner",
      fn: function () {
        return [_c(VAvatar, {
          staticClass: "mr-1",
          attrs: {
            "size": "20"
          }
        }, [_vm.selectedBridgeConfig && (_vm.localBridgeConfigs.find(d => d.type === _vm.selectedBridgeConfig.type) || {}).image ? [_c('img', {
          attrs: {
            "src": (_vm.localBridgeConfigs.find(d => d.type === _vm.selectedBridgeConfig.type) || {}).image,
            "alt": (_vm.localBridgeConfigs.find(d => d.type === _vm.selectedBridgeConfig.type) || {}).title,
            "title": (_vm.localBridgeConfigs.find(d => d.type === _vm.selectedBridgeConfig.type) || {}).title
          }
        })] : _vm._e()], 2)];
      },
      proxy: true
    }, {
      key: "append-outer",
      fn: function () {
        return [_vm.selectedBridgeConfig && _vm.hasManageAllPermissions ? _c('core-button', {
          staticClass: "info-button",
          attrs: {
            "color": _vm.color,
            "title": _vm.selectedBridgeConfig.title,
            "prepend-icon": "fa-info-circle"
          },
          on: {
            "click": function ($event) {
              return _vm.openBridgeConfig();
            }
          }
        }) : _vm._e(), _vm.showRetryButton ? _c('core-button', {
          staticClass: "info-button",
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-redo"
          },
          on: {
            "click": function ($event) {
              return _vm.retryFetchBridges();
            }
          }
        }) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selectedBridgeConfig,
      callback: function ($$v) {
        _vm.selectedBridgeConfig = $$v;
      },
      expression: "selectedBridgeConfig"
    }
  }), _vm.showRetryButton ? _c('span', {
    staticClass: "error--text"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Connectors.Connectors.errors.errorWhileFetchingConnectos')) + "\n      ")]) : _vm._e()], 1), _vm.selectedBridgeConfig && _vm.selectedBridgeConfig.type && _vm.bridgeComponentExists ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(`core-dtwin-state-bridge-${_vm.baseBridgeType}`, {
    ref: `${_vm.baseBridgeType}-bridge-config`,
    tag: "component",
    attrs: {
      "lclModel": _vm.lclModel,
      "bridgeConfig": _vm.selectedBridgeConfig,
      "mode": _vm.mode,
      "disabled": _vm.templateContext,
      "templateContext": _vm.templateContext
    },
    on: {
      "bridge-binding-changed": _vm.bridgeBindingChanged,
      "no-permission": e => _vm.$emit('no-permission', e)
    }
  })], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };